"use client";

import { c as _c } from "react/compiler-runtime";
import { PlusIcon } from "@heroicons/react/24/outline";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWaveCurations } from "@/hooks/waves/useWaveCurations";
import MyStreamActionTooltip from "../MyStreamActionTooltip";
import MyStreamWaveCurationCreateDialog from "./MyStreamWaveCurationCreateDialog";
import { useState } from "react";
interface MyStreamWaveCreateCurationActionProps {
  readonly wave: ApiWave;
  readonly onCreated: (curationId: string) => void;
}
export default function MyStreamWaveCreateCurationAction(t0) {
  const $ = _c(17);
  const {
    wave,
    onCreated
  } = t0;
  let t1;
  if ($[0] !== wave.id) {
    t1 = {
      waveId: wave.id
    };
    $[0] = wave.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: t2
  } = useWaveCurations(t1);
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const curations = t3;
  const canManageCurations = wave.wave.authenticated_user_eligible_for_admin === true;
  const [isCreateCurationOpen, setIsCreateCurationOpen] = useState(false);
  if (!canManageCurations) {
    return null;
  }
  const createCurationTooltipId = `my-stream-create-curation-${wave.id}`;
  const showCreateFirstCurationCallout = curations.length === 0;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsCreateCurationOpen(true);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleOpenCreateCuration = t4;
  let t5;
  let t6;
  if ($[5] !== createCurationTooltipId || $[6] !== showCreateFirstCurationCallout) {
    t5 = <div className="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-2">{showCreateFirstCurationCallout ? <button type="button" onClick={handleOpenCreateCuration} className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-transition desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-white tw-text-xs tw-font-semibold tw-text-iron-100 md:tw-h-auto md:tw-w-auto md:tw-gap-2 md:tw-rounded-lg md:tw-px-3.5 md:tw-py-2" aria-label="Create curation"><PlusIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0 md:-tw-ml-1" /><span className="tw-hidden tw-whitespace-nowrap md:tw-inline">Create first curation</span></button> : <button type="button" onClick={handleOpenCreateCuration} data-tooltip-id={createCurationTooltipId} data-tooltip-content="Create curation" className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-transition desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-white tw-text-iron-200" aria-label="Create curation"><PlusIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" /></button>}</div>;
    t6 = !showCreateFirstCurationCallout && <MyStreamActionTooltip id={createCurationTooltipId} />;
    $[5] = createCurationTooltipId;
    $[6] = showCreateFirstCurationCallout;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isCreateCurationOpen || $[10] !== onCreated || $[11] !== wave) {
    t7 = isCreateCurationOpen && <MyStreamWaveCurationCreateDialog wave={wave} isOpen={isCreateCurationOpen} onClose={() => setIsCreateCurationOpen(false)} onSaved={curation => onCreated(curation.id)} />;
    $[9] = isCreateCurationOpen;
    $[10] = onCreated;
    $[11] = wave;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <>{t5}{t6}{t7}</>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}